<template>
  <div class="info" flex="box:mean" :style="{height}">
    <div class="info__row" flex="dir:top box:mean cross:center">
      <div flex="cross:center">今日收益</div>
      <div flex="cross:center" class="info--yellow">
        <span>￥200000</span>
      </div>
    </div>
    <div class="info__row" flex="dir:top box:mean cross:center">
      <div flex="cross:center">全部收益</div>
      <div flex="cross:center" class="info--yellow">￥200000</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    height: {
      type: String,
      default: "110px"
    }
  },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.info {
  background-color: rgba(64, 162, 118, 0);
  border-image-source: url("../../image/border.png");
  border-image-slice: 10;
  border-image-width: 3;
  border-style: solid;
  box-sizing: border-box;
  width: 100%;
  height: 109px;
  touch-action: none;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  &__row {
    height: 100%;
  }
  &--yellow {
    color: rgb(255, 255, 27);
    font-size: 20px;
    font-family: HKGRTESK;
  }
}
</style>
